import React from 'react';
import Logo from '../../../static/NaturedotsLogo.svg';
import Privacy from '../../../static/Privacy.svg';
import { useNavigate } from 'react-router-dom';

export default function UsePolicyHeader() {
	const [isHindiSelected, setIsHindiSelected] = React.useState(true);
	const navigate = useNavigate();
	return (
		<div className='flex flex-col'>
			<div className='sm:hidden px-4 flex flex-col space-y-4 mt-4'>
				<p className='text-[#9F9F9] text-base'>Agreement</p>
				<p className='text-[#000088] font-bold text-xl'>
					Legal- TERMS OF USE POLICY
				</p>
				<div className='flex items-center space-x-10 '>
					<label className='flex items-center space-x-2'>
						<input
							type='radio'
							value='option1'
							checked={isHindiSelected === true}
							onChange={() => setIsHindiSelected(true)}
							className='form-radio text-blue-500 cursor-pointer'
						/>
						<span>हिन्दी</span>
					</label>

					<label className='flex items-center space-x-2'>
						<input
							type='radio'
							value='option2'
							checked={isHindiSelected === false}
							onChange={() => setIsHindiSelected(false)}
							className='form-radio text-blue-500 cursor-pointer'
						/>
						<span>English</span>
					</label>
				</div>
			</div>
			<div className='hidden sm:block h-[250px] w-full bg-[#F3F3FB]'>
				<div className='flex px-20 py-5'>
					<img
						className=' cursor-pointer h-[50px]'
						src={Logo}
						alt='logoImg'
						onClick={() => navigate('/')}
					/>
					<div className='flex flex-col space-y-4 items-center flex-1'>
						<img
							className=' cursor-pointer h-[130px] w-[200px]'
							src={Privacy}
							alt='logoImg'
						/>
						<p className='text-[#000088] font-bold text-2xl'>
							Legal - TERMS OF USE POLICY
						</p>
						<div className='flex items-center space-x-10 '>
							<label className='flex items-center space-x-2'>
								<input
									type='radio'
									value='option1'
									checked={isHindiSelected === true}
									onChange={() => setIsHindiSelected(true)}
									className='form-radio text-blue-500 cursor-pointer'
								/>
								<span>हिन्दी</span>
							</label>

							<label className='flex items-center space-x-2'>
								<input
									type='radio'
									value='option2'
									checked={isHindiSelected === false}
									onChange={() => setIsHindiSelected(false)}
									className='form-radio text-blue-500 cursor-pointer'
								/>
								<span>English</span>
							</label>
						</div>
					</div>
				</div>
			</div>

			<div className='flex flex-col px-4 sm:px-20 py-5 h-full space-y-8 mt-5'>
				<div className='flex flex-col space-y-3'>
					<div className='flex items-center  w-full'>
						<p className='text-base font-semibold leading-6 text-black'>
							1. {isHindiSelected ? 'परिभाषा' : 'Definitions'}
						</p>
					</div>
					<div className='flex items-center  w-full'>
						<p className='text-base font-semibold leading-6 text-black'>
							2. {isHindiSelected ? 'परिचय' : 'Introduction'}
						</p>
					</div>
					<div className='flex items-center  w-full'>
						<p className='text-base font-semibold leading-6 text-black'>
							3.{' '}
							{isHindiSelected
								? 'वेबसाइट का एक्सेस और उपयोग-'
								: 'Access and use of the Website'}
						</p>
					</div>
					<div className='flex items-center w-full'>
						<p className='text-base font-semibold leading-6 text-black'>
							4.{' '}
							{isHindiSelected
								? 'बौद्धिक संपदा अधिकार'
								: 'Intellectual Property Rights'}
						</p>
					</div>
					<div className='flex items-center w-full'>
						<p className='text-base font-semibold leading-6 text-black'>
							5.{' '}
							{isHindiSelected
								? 'वारंटी और देयताएं'
								: 'Warranties and Liabilities'}
						</p>
					</div>
					<div className='flex items-center w-full'>
						<p className='text-base font-semibold leading-6 text-black'>
							6. {isHindiSelected ? 'क्षतिपूर्ति' : 'Indemnification'}
						</p>
					</div>
					<div className='flex items-center w-full'>
						<p className='text-base font-semibold leading-6 text-black'>
							7. {isHindiSelected ? 'समापन' : 'Termination'}
						</p>
					</div>
					<div className='flex items-center w-full'>
						<p className='text-base font-semibold leading-6 text-black'>
							8. {isHindiSelected ? 'सामान्य प्रावधान' : 'General provisions'}
						</p>
					</div>
				</div>

				<div className='flex flex-col text-black'>
					<p className='text-black font-bold text-xl'>
						1. {isHindiSelected ? 'परिभाषाएं' : 'DEFINITIONS'}
					</p>
					<div className='flex flex-col mt-1 text-sm font-normal leading-6 text-black ml-5'>
						<p>
							1.1.{' '}
							{isHindiSelected
								? 'इस दस्तावेज़ में, जब तक संदर्भ अन्यथा अपेक्षित न हो,'
								: 'In this document, unless the context otherwise requires:'}
						</p>
						<p className='ml-2'>
							1.1.1.{' '}
							<span className='font-bold'>
								{isHindiSelected ? '‘डिवाइस’' : '‘Device’'}
							</span>{' '}
							{isHindiSelected
								? 'का अर्थ है कोई भी डिजिटल उपकरण जो आमतौर पर इलेक्ट्रॉनिक होता है, जो डेटा को निर्देशों के सेट के अनुसार संसाधित करता है, जिसमें वर्कस्टेशन, व्यक्तिगत कंप्यूटर, लैपटॉप, नेटबुक, व्यक्तिगत डिजिटल सहायक, टैबलेट और स्मार्टफोन शामिल हो सकते हैं;'
								: 'means any digital instrument, usually electronic, that processes data according to a set of instructions, which may include workstations, personal computers, laptops, netbooks, personal digital assistants, tablets, and smartphones;'}
						</p>
						<p className='ml-2'>
							1.1.2.{' '}
							<span className='font-bold'>
								{isHindiSelected ? '‘नेचरडॉट्स’' : '‘NatureDots’'}
							</span>{' '}
							{isHindiSelected
								? 'का अर्थ नेचरडॉट्स प्राइवेट लिमिटेड, एक कंपनी है जो कंपनी अधिनियम, 2013 के तहत पंजीकृत है, जिसका पता ए-52, जीतार नगर, नई दिल्ली 110051 है;'
								: 'means NatureDots Private Limited, a company registered under the Companies Act, 2013, at A-52, Jitar Nagar, New Delhi 110051;'}
						</p>
						<p className='ml-2'>
							1.1.3.{' '}
							<span className='font-bold'>
								{isHindiSelected ? '‘गोपनीयता नीति’' : '‘Privacy Policy’'}
							</span>{' '}
							{isHindiSelected
								? 'का अर्थ उपयोगकर्ता के डेटा को नियंत्रित करने वाली शर्तें और शर्तें हैं और नैचुरडॉट्स की वेबसाइट पर प्रदान की गई हैं।'
								: 'means the terms and conditions governing data from the User as provided at the Website of NatureDots.'}
						</p>
						<p className='ml-2'>
							1.1.4.{' '}
							<span className='font-bold'>
								{isHindiSelected ? '‘उपयोग की शर्तें’' : '‘Terms of Use’'}
							</span>{' '}
							{isHindiSelected
								? 'का अर्थ है वेबसाइट की नियम और शर्तें जो वेबसाइट के उपयोग के संबंध में प्रावधान करती हैं;'
								: 'means the Website terms and conditions containing the provisions regarding the use of the Website;'}
						</p>
						<p className='ml-2'>
							1.1.5.{' '}
							<span className='font-bold'>
								{isHindiSelected ? '‘अपग्रेड्स’' : '‘Upgrades’'}
							</span>{' '}
							{isHindiSelected
								? 'का अर्थ नई वेबसाइट का नया संस्करण और अपडेट है, चाहे वह वेबसाइट में त्रुटि, बग या अन्य समस्या को ठीक करने के लिए हो या वेबसाइट की कार्यक्षमता को बढ़ाने के लिए हो।'
								: 'means new versions of, and updates to, the Website, whether for the purpose of fixing an error, bug, or other issue in the Website or enhancing the functionality of the Website.'}
						</p>
						<p className='ml-2'>
							1.1.6.{' '}
							<span className='font-bold'>
								{isHindiSelected ? '‘उपयोगकर्ता’' : '‘User’'}
							</span>{' '}
							{isHindiSelected
								? 'का अर्थ है वेबसाइट का आगंतुक या उपयोगकर्ता, और ग्राहक भी शामिल हैं;'
								: 'means the visitor or the person using the Website, and includes customers;'}
						</p>
						<p className='ml-2'>
							1.1.7. {isHindiSelected ? '‘वेबसाइट’' : '‘Website’'}{' '}
							{isHindiSelected
								? 'का अर्थ नेचरडॉट्स की वर्तमान वेबसाइट है यानी '
								: 'means the present Website of NatureDots i.e. '}
							<span
								className='cursor-pointer ml-1 font-bold'
								onClick={() => navigate('/')}
							>
								www.naturedots.com
							</span>
						</p>
						<p>
							1.2.{' '}
							{isHindiSelected
								? 'यहां परिभाषित नहीं किए गए शब्दों को संदर्भ के साथ उनके शाब्दिक अर्थ में लिया जाएगा।'
								: 'Words not defined herein are to be given their literal meaning accompanied by the context.'}
						</p>
					</div>
				</div>

				<div className='flex flex-col text-black'>
					<p className='text-black font-bold text-xl'>
						2. {isHindiSelected ? 'परिचय' : 'INTRODUCTION'}
					</p>
					<div className='flex flex-col mt-1 text-sm font-normal leading-6 text-black ml-5'>
						<p>
							2.1.{' '}
							{isHindiSelected
								? 'नेचरडॉट्स के पास वेबसाइट का कॉपीराइट है और इसे लाइसेंस देने या इसे छोड़ने का अधिकार सुरक्षित है। नेचरडॉट्स केवल उपयोगकर्ता को वेबसाइट "जैसी है" "सभी दोषों के साथ" और "उपलब्ध" आधार पर प्रदान करता है।'
								: 'NatureDots possess the copyright of the Website and reserves its right to license or relinquish it. NatureDots merely provides the Website on an "as-is," "with all faults," and "as available" basis to the User.'}
						</p>
						<p>
							2.2.{' '}
							{isHindiSelected
								? 'वेबसाइट के मात्र उपयोग से, उपयोगकर्ता सहमत होता है कि वह उपयोग की शर्तों का पालन करेगा और उनसे बाध्य होगा। NatureDots इस वेबसाइट, सहित सभी जानकारी, उपकरण और सेवाएं जो इस साइट से उपलब्ध हैं, उपयोगकर्ता के स्वीकार करने की शर्त पर प्रदान करता है। यदि उपयोगकर्ता उपयोग की शर्तों का पालन करने और उनसे बाध्य होने से असहमत है, तो ऐसे उपयोगकर्ता को NatureDots की वेबसाइट तक पहुंच नहीं दी जाएगी। यदि उपयोगकर्ता कोई संस्था, संगठन या कंपनी है, तो ऐसे व्यक्ति द्वारा ऐसी संस्था, संगठन या कंपनी का प्रतिनिधित्व और वारंटी दी जाती है कि उनके पास इन उपयोग की शर्तों को बाध्य करने का अधिकार है।'
								: 'By merely using the Website, the User agrees to comply with and be bound by the Terms of Use. NatureDots offers this Website, including all information, tools, and services available from this site to the User, conditioned upon the User’s acceptance of all terms, conditions, privacy policies, and notices stated here. If the User disagrees with complying with and being bound by the Terms of Use, then such User is not allowed to access the Website of NatureDots. If the User is an entity, organization, or company, then such individual on behalf of such entity, organization, or company represents and warrants that they have the authority to bind such entity, organization, or company to the Terms of Use.'}
						</p>
						<p>
							2.3.{' '}
							{isHindiSelected
								? 'वेबसाइट का उपयोग, ब्राउज़ करना या अन्यथा उपयोग करना उपयोगकर्ता की सहमति को इंगित करता है कि वह इन उपयोग की शर्तों के तहत सभी नियमों और शर्तों से सहमत है। इन उपयोग की शर्तों को स्पष्ट या निहित रूप से स्वीकार करके, उपयोगकर्ता गोपनीयता नीति (समय-समय पर संशोधित) को भी स्वीकार करता है और उससे बाध्य होता है।'
								: 'Accessing, browsing, or otherwise using the Website indicates the User’s agreement to all the terms and conditions under these Terms of Use. By impliedly or expressly accepting these Terms of Use, the User also accepts and agrees to be bound by the privacy policy (as amended from time to time).'}
						</p>
						<p>
							2.4.{' '}
							{isHindiSelected
								? 'इस वेबसाइट का उपयोग करके, उपयोगकर्ता यह दर्शाता है और वारंटी देता है कि:'
								: 'By using this Website, the User represents and warrants that:'}
						</p>
						<p className='ml-2'>
							a){' '}
							{isHindiSelected
								? 'वे कम से कम 18 वर्ष के हैं;'
								: 'they are at least 18 years old;'}
						</p>
						<p className='ml-2'>
							b){' '}
							{isHindiSelected
								? 'उनके पास अनुबंध करने और इन उपयोग की शर्तों से बंधे होने का वैध अधिकार और क्षमता है;'
								: 'they have the lawful authority and capacity to contract and be bound by these Terms of Use;'}
						</p>
						<p className='ml-2'>
							c){' '}
							{isHindiSelected
								? 'यदि वे किसी कंपनी, सीमित देयता साझेदारी या अन्य कानूनी इकाई की ओर से इन उपयोग की शर्तों को स्वीकार कर रहे हैं, तो उनके पास इन उपयोग की शर्तों के लिए ऐसी इकाई को बाध्य करने का अधिकार है और,'
								: 'If they are accepting these Terms of Use on behalf of a company, limited liability partnership, or other legal entity, they have the authority to bind such entity to these Terms of Use and,'}
						</p>
						<p className='ml-2'>
							d){' '}
							{isHindiSelected
								? 'वे सभी लागू कानूनों और विनियमों का पालन करते हैं।'
								: 'they comply with all applicable laws and regulations.'}
						</p>
					</div>
				</div>

				<div className='flex flex-col text-black'>
					<p className='text-black font-bold text-xl'>
						3.{' '}
						{isHindiSelected
							? 'वेबसाइट का एक्सेस और उपयोग-'
							: 'ACCESS AND USE OF THE WEBSITE'}
					</p>
					<div className='flex flex-col mt-1 text-sm font-normal leading-6 text-black ml-5'>
						<p>
							3.1.{' '}
							{isHindiSelected
								? 'NatureDots उपयोगकर्ता को उपयोग की शर्तों और निम्नलिखित प्रतिनिधित्व और वारंटियों के अधीन वेबसाइट का सीमित, व्यक्तिगत, गैर-एक्सक्लूसिव और गैर-सब लाइसेंसेबल उपयोग करने का अधिकार देता है:'
								: 'NatureDots grants the User a limited, personal, non-exclusive and non-sublicensable right to use the Website, subject to the Terms of Use and the following representations and warranties:'}
						</p>
						<p>
							3.1.1.{' '}
							{isHindiSelected
								? 'उपयोगकर्ता केवल अधिकृत और वैध साधनों का उपयोग करके वेबसाइट तक पहुंच सकता है;'
								: 'The User may only access the Website using authorized and lawful means;'}
						</p>
						<p>
							3.1.2.{' '}
							{isHindiSelected
								? 'उपयोगकर्ता के द्वारा ऐसी पहुंच के लिए वेबसाइट में पंजीकरण करने में विफलता या देरी के कारण वेबसाइट तक पहुंच प्रदान करने में विफलता या डिफ़ॉल्ट के लिए NatureDots उत्तरदायी नहीं होगा;'
								: 'NatureDots shall not be liable for any failure or default to provide access to the Website on account of any failure or delay by the User to register with the Website for such access;'}
						</p>
						<p>
							3.1.3.{' '}
							{isHindiSelected
								? 'उपयोगकर्ता के लिए उपकरणों की किसी भी कॉन्फ़िगरेशन या सेटअप की जिम्मेदारी उपयोगकर्ता की होगी।'
								: 'Any configuration or set up of devices for access to the Website shall be the User’s sole responsibility.'}
						</p>
						<p>
							3.1.4.{' '}
							{isHindiSelected
								? 'NatureDots गोपनीयता नीति के अनुसार उपयोगकर्ता की जानकारी को एकत्रित, संग्रहीत, प्रोसेस और उपयोग करता है। वेबसाइट का उपयोग करके और/या व्यक्तिगत जानकारी, गैर-व्यक्तिगत जानकारी और अन्य जानकारी प्रदान करके, उपयोगकर्ता गोपनीयता नीति के अनुसार ऐसी जानकारी के संग्रह और उपयोग के लिए सहमत होता है;'
								: 'NatureDots collect, store, process and use the User’s information in accordance with NatureDots’ Privacy Policy. By using the Website and/or by providing personal information, non-personal information and other information, the User consents to the collection and use of such information as per the Privacy Policy;'}
						</p>
						<p>
							3.1.5.{' '}
							{isHindiSelected
								? 'उपयोगकर्ता जानबूझकर कोई भी गलत या अशुद्ध जानकारी व्यक्तिगत जानकारी, गैर-व्यक्तिगत जानकारी और अन्य जानकारी के रूप में प्रस्तुत या उपयोग नहीं करेगा।'
								: 'The User will not knowingly submit or use any false or inaccurate information as the Personal Information, non-personal information and other information.'}
						</p>
						<p className='ml-2'>
							3.1.6.{' '}
							{isHindiSelected
								? 'उपयोगकर्ता ऐसी कोई भी कार्रवाई नहीं करेगा जो NatureDots और/या वेबसाइट के साथ हस्तक्षेप करती है, उसकी गुणवत्ता को कम करती है या प्रतिकूल प्रभाव डालती है;'
								: 'The User shall not take any action that interferes with, degrades or adversely affects NatureDots and/or the Website;'}
						</p>
						<p className='ml-2'>
							3.1.7.{' '}
							{isHindiSelected
								? 'उपयोगकर्ता वेबसाइट का उपयोग इस प्रकार नहीं करेगा-'
								: 'The User will not use the Website in a manner-'}
						</p>
						<p className='ml-4'>
							a){' '}
							{isHindiSelected
								? 'भारत के किसी भी कानून या विनियमन के विपरीत;'
								: 'contrary to any law or regulation of India;'}
						</p>
						<p className='ml-4'>
							b){' '}
							{isHindiSelected
								? 'जिससे किसी तीसरे पक्ष के समान उपयोग में बाधा उत्पन्न हो;'
								: 'which can disrupt a third parties’ similar use;'}
						</p>
						<p className='ml-4'>
							c){' '}
							{isHindiSelected
								? 'NatureDots के हितों को नुकसान या उल्लंघन;'
								: 'harm or violates the interests of NatureDots;'}
						</p>
						<p className='ml-4'>
							d){' '}
							{isHindiSelected
								? 'वेबसाइट की सुरक्षा का उल्लंघन या उसमें छेड़छाड़ करना;'
								: 'violate or tamper with the security of the Website;'}
						</p>
						<p className='ml-2'>
							3.1.8.{' '}
							{isHindiSelected
								? 'उपयोगकर्ता वेबसाइट, या इसके किसी भी हिस्से का उपयोग, अनुचित, उत्पीड़क, अभद्र, अमर्यादित, अश्लील, गैरकानूनी या धोखाधड़ी वाले सामग्री को संचारित, प्रकाशित, पोस्ट, अपलोड, वितरित या प्रसारित करने के लिए नहीं करेगा;'
								: 'The User will not use the Website, or any portion thereof, to transmit, publish, post, upload, distribute or disseminate any inappropriate, harassing, abusive, defamatory, libel, obscene, illegal or deceptive content;'}
						</p>
						<p className='ml-2'>
							3.1.9.{' '}
							{isHindiSelected
								? 'उपयोगकर्ता यह सुनिश्चित करेगा कि वेबसाइट का उपयोग किसी वायरस या किसी अन्य प्रकार के दुर्भावनापूर्ण कोड या डेटा को अपलोड, पोस्ट, ट्रांसमिट या अन्यथा उपलब्ध कराने के लिए नहीं किया जाएगा जो वेबसाइट या किसी अन्य सॉफ़्टवेयर, हार्डवेयर, सेवाओं या डेटा पर प्रतिकूल प्रभाव डालने के लिए या वेबसाइट को अनुचित पहुंच प्रदान करने के लिए या वेबसाइट के हिस्से के लिए नहीं किया जाएगा;'
								: 'The User shall ensure that the Website is not used to upload, post, transmit, or otherwise make available any content that contains a virus or any other form of malicious code or data that is likely or intended to have an adverse impact on, or provide unauthorized access to, the Website or any other software, hardware, services or data;'}
						</p>
						<p className='ml-2'>
							3.1.10.{' '}
							{isHindiSelected
								? 'उपयोगकर्ता हैकिंग या किसी अन्य तरीके से वेबसाइट से जुड़े किसी भी खाते, कंप्यूटर सिस्टम या नेटवर्क तक अनधिकृत पहुंच प्राप्त करने का प्रयास नहीं करेगा, या उपयोगकर्ता के लिए जानबूझकर उपलब्ध नहीं कराए गए किसी भी सामग्री या जानकारी को प्राप्त करने या प्राप्त करने का प्रयास नहीं करेगा;'
								: 'The User shall not attempt to gain unauthorized access to any accounts, computer systems or networks connected to the Website, through hacking, or any other means, or obtain or attempt to obtain any materials or information through any means not intentionally made available to the User;'}
						</p>
						<p className='ml-2'>
							3.1.11.{' '}
							{isHindiSelected
								? 'उपयोगकर्ता वेबसाइट, इसकी सामग्री या सामग्री और/या सेवाओं के किसी भी हिस्से को कॉपी, संशोधित, अनुकूलित, अनुवाद या रिवर्स इंजीनियर नहीं करेगा। उपयोगकर्ता वेबसाइट का उपयोग प्रतिस्पर्धी वेबसाइट, सेवा या अन्य प्रतिस्पर्धी उद्देश्यों के लिए विकसित करने या किसी को भी विकसित करने में सहायता करने के लिए नहीं करेगा;'
								: 'The User shall not copy, modify, adapt, translate, or reverse engineer any portion of the Website, its content or materials and/or the services. The User will not use the Website to develop, or to assist anyone in developing a competitive website, service or for other competitive purposes;'}
						</p>
						<p className='ml-2'>
							3.1.12.{' '}
							{isHindiSelected
								? 'उपयोगकर्ता निम्नलिखित के लिए अकेले जिम्मेदार होगा-'
								: 'The User shall be solely responsible for-'}
						</p>
						<p className='ml-4'>
							a){' '}
							{isHindiSelected
								? 'अपने सिस्टम से कंपनी के डेटा केंद्रों तक नेटवर्क कनेक्शन और दूरसंचार लिंक प्राप्त करने और बनाए रखने के लिए और'
								: 'procuring and maintaining its network connections and telecommunications links from its systems to the Company’s data centres and'}
						</p>
						<p className='ml-4'>
							b){' '}
							{isHindiSelected
								? 'इंटरनेट से संबंधित या इससे उत्पन्न होने वाली सभी समस्याओं, स्थितियों, देरियों, वितरण विफलताओं और अन्य सभी नुकसान या क्षति के लिए;'
								: 'all problems, conditions, delays, delivery failures and all other loss or damage arising from or relating to its network connections or telecommunications links or caused by the internet;'}
						</p>
						<p className='ml-2'>
							3.1.13.{' '}
							{isHindiSelected
								? 'उपयोगकर्ता स्वीकार करता है कि समय-समय पर, NatureDots अपग्रेड और/या वेबसाइट की कार्यक्षमता लागू कर सकता है। उपयोगकर्ता को वेबसाइट तक पहुंच जारी रखने या उपयोग करने के लिए, या उसके कुछ हिस्सों तक पहुंच जारी रखने के लिए सॉफ़्टवेयर को कुछ अपग्रेड या अपडेट इंस्टॉल करने की आवश्यकता हो सकती है।'
								: 'The User acknowledges that from time to time, NatureDots may apply Upgrades and/or functionality of Website. The User may be required to install certain Upgrades or updates to the software in order to continue to access or use the Website, or portions thereof.'}
						</p>
						<p>
							3.2.{' '}
							{isHindiSelected
								? 'वेबसाइट के माध्यम से प्रसारित सभी संचार, जिसमें बिना किसी सीमा के, NatureDots का संदेश वेबसाइट और ऑडियो-वीडियो कॉल की गुणवत्ता आश्वासन, प्रशिक्षण, रिकॉर्ड-कीपिंग और अन्य उद्देश्यों के लिए निगरानी की जाएगी। इन उपयोग की शर्तों को स्वीकार करके, उपयोगकर्ता इस तरह की किसी भी निगरानी के लिए सहमति देते हैं, जैसा कि गोपनीयता नीति के अनुसार है।'
								: 'All communications transmitted through the Website, including without limitation, the NatureDots’ messaging website and audio-video calls shall be monitored for quality assurance, training, record-keeping and other purposes. By accepting these Terms of Use, the User consent to any such monitoring, as per the privacy policy.'}
						</p>
						<p>
							3.3.{' '}
							{isHindiSelected
								? 'वेबसाइट में अन्य वेबसाइटों के लिंक हो सकते हैं जो अन्य व्यक्तियों और कंपनियों के नियंत्रण में हैं। NatureDots इन वेबसाइटों की सामग्री के लिए जिम्मेदार नहीं है और उनका समर्थन नहीं करता है।'
								: 'The Website may contain links to other Websites which fall under control of other individuals and companies. NatureDots is not responsible for and does not endorse the contents of these Websites.'}
						</p>
						<p>
							3.4.{' '}
							{isHindiSelected
								? 'एक सावधान और व्यवहारिक व्यक्ति के रूप में, उपयोगकर्ता वेबसाइट के अन्य उपयोगकर्ताओं के लिए प्रतिपुष्टि छोड़ते समय सावधानी बरतने, सतर्क रहने और अच्छा निर्णय लेने से सहमत है। ऐसे प्रतिपुष्टि के मामले में जो अनुचित हों या किसी अन्य उपयोगकर्ता की मर्यादा या गोपनीयता का उल्लंघन करें, NatureDots अपने एकमात्र विवेक में, उपयोगकर्ता की प्रतिपुष्टि या किसी भी पोस्टिंग को हटा सकता है; और किसी भी गैरकानूनी गतिविधि के लिए कानून प्रवर्तन प्राधिकरणों को रिपोर्ट कर सकता है, और वेबसाइट पर ऐसे आचरण की किसी भी रिपोर्ट प्राप्त करेगा। जब कभी कानूनी रूप से आवश्यक हो या अपने विवेक पर, NatureDots वेबसाइट पर किसी भी गैरकानूनी गतिविधि की जांच में कानून प्रवर्तन एजेंसियों के साथ सहयोग करेगा।'
								: 'As a diligent and behaved person, the User agrees to exercise care, be prudent, and exhibit good judgment while leaving feedback for other Users of the Website. In case of feedbacks which are inappropriate or violates propriety or privacy of another User, NatureDots in its sole discretion, may delete the User’s feedback or any of the postings; and may report to law enforcement authorities for any actions that may be illegal, and any reports it receives of such conduct. Whenever legally required or at its discretion, NatureDots will cooperate with law enforcement agencies in any investigation of alleged illegal activity on the Website.'}
						</p>
						<p>
							3.5.{' '}
							{isHindiSelected
								? 'उपयोगकर्ता किसी भी अनुचित उपयोग की रिपोर्ट करने के लिए reachus@naturedots.com पर NatureDots से संपर्क कर सकते हैं।'
								: 'The User may contact NatureDots regarding any inappropriate use of feedback via-email at reachus@naturedots.com.'}
						</p>
					</div>
				</div>

				<div className='flex flex-col text-black'>
					<p className='text-black font-bold text-xl'>
						4.{' '}
						{isHindiSelected
							? 'बौद्धिक संपदा अधिकार'
							: 'INTELLECTUAL PROPERTY RIGHTS'}
					</p>
					<div className='flex flex-col mt-1 text-sm font-normal leading-6 text-black ml-5'>
						<p>
							4.1.{' '}
							{isHindiSelected
								? 'उपयोगकर्ता स्वीकार करता है कि वेबसाइट से संबंधित किसी भी और सभी बौद्धिक संपदा अधिकारों (ट्रेडमार्क, कॉपीराइट, पेटेंट, डिज़ाइन, सर्विस मार्क आदि सहित लेकिन इन तक सीमित नहीं) और अन्य संपदा अधिकार (किसी तीसरे पक्ष की व्यक्तिगत जानकारी, बौद्धिक संपदा को छोड़कर) का स्वामित्व और आरोपण NatureDots के पास है और वह किसी भी तीसरे पक्ष को उल्लंघन नहीं करने और न ही करने का वचन देता है। वेबसाइट तक उपयोगकर्ता की पहुंच &#39;जैसी है&#39; आधार पर सीमित दी जाती है।'
								: 'The User acknowledges that any and all intellectual property rights (including but not limited to all trademark, copyright, patent, design, service marks, etc.) and other proprietary rights in relation to the Website including without limitation any derivatives, improvements or modifications is owned and attributable to NatureDots (excluding any personal information, intellectual property which belongs to a third party) and agrees not to infringe and cause any third-party to infringe. The User’s access to the Website is given on limited ‘as-is’ basis.'}
						</p>
						<p>
							4.2.{' '}
							{isHindiSelected
								? 'वेबसाइट या सेवाओं से संबंधित उपयोगकर्ता या किसी अन्य पक्ष द्वारा प्रदान की गई कोई भी सुझाव, विचार, वृद्धि अनुरोध, प्रतिक्रिया, सिफारिशें या अन्य जानकारी पूरी दुनिया में NatureDots के साथ पूरी तरह से और पूरी तरह से निहित होगी और उपयोगकर्ता के पास किसी भी तरह से ऐसे बौद्धिक संपदा पर कोई अधिकार या दावा नहीं होगा।'
								: 'Any suggestions, ideas, enhancement requests, feedback, recommendations or other information provided by the User or any other party relating to the Website or the services shall vest wholly completely and fully with NatureDots throughout the world and the User shall have no right or claim to such intellectual property in any manner whatsoever.'}
						</p>
					</div>
				</div>

				<div className='flex flex-col text-black'>
					<p className='text-black font-bold text-xl'>
						5.{' '}
						{isHindiSelected
							? 'वारंटी और देनदारियां'
							: 'WARRANTIES AND LIABILITIES'}
					</p>
					<div className='flex flex-col mt-1 text-sm font-normal leading-6 text-black ml-5'>
						<p>
							5.1.{' '}
							{isHindiSelected
								? 'उपयोगकर्ता समझता है और सहमत है कि वेबसाइट का उपयोग अपने जोखिम पर किया जाता है। व्यापारिकता, किसी विशिष्ट उद्देश्य के लिए उपयुक्तता, शीर्षक और गैर-उल्लंघन सहित सभी वारंटियों को अस्वीकार और बाहर कर दिया गया है।'
								: 'The User understands and agrees that use of the Website is at its own risk. All warranties including without limitation, the implied warranties of merchantability, fitness for a particular purpose, for title and non- infringement are disclaimed and excluded.'}
						</p>
						<p>
							5.2.{' '}
							{isHindiSelected
								? 'NatureDots निम्नलिखित के बारे में कोई प्रतिनिधित्व, वारंटी या गारंटी नहीं देता है:'
								: 'NatureDots does not make any representation, warrants or guarantees whatsoever regarding the:'}
						</p>
						<p className='ml-2'>
							a){' '}
							{isHindiSelected
								? 'वेबसाइट पर जानकारी की सटीकता, पर्याप्तता, विश्वसनीयता, पूर्णता, उपयुक्तता या लागूता किसी विशेष स्थिति के लिए;'
								: 'accuracy, adequacy, reliability, completeness, suitability or applicability of the information on the Website to a particular situation;'}
						</p>
						<p className='ml-2'>
							b){' '}
							{isHindiSelected
								? 'कि वेबसाइट की सुविधाएँ बिना रुके, समय पर, सुरक्षित, या त्रुटि-मुक्त होंगी;'
								: 'that the features on the Website will be uninterrupted, timely, secure, or error-free;'}
						</p>
						<p className='ml-2'>
							c){' '}
							{isHindiSelected
								? 'वेबसाइट पर किसी भी सेवाओं, सामग्री, जानकारी या अन्य सामग्री की गुणवत्ता उपयोगकर्ता की अपेक्षाओं या आवश्यकताओं को पूरा करेगी;'
								: 'the quality of any services, content, information, or other material on the Website will meet the User’s expectations or requirements;'}
						</p>
						<p className='ml-2'>
							d){' '}
							{isHindiSelected
								? 'वेबसाइट में कोई भी त्रुटि ठीक की जाएगी;'
								: 'any errors in the Website will be corrected;'}
						</p>
						<p className='ml-2'>
							e){' '}
							{isHindiSelected
								? 'किसी तीसरे पक्ष के बौद्धिक संपदा या स्वामित्व अधिकारों का उल्लंघन करने के खिलाफ वारंटी; या'
								: 'warranties against infringement of any third-party intellectual property or proprietary rights; or'}
						</p>
						<p className='ml-2'>
							f){' '}
							{isHindiSelected
								? 'NatureDots, इसके अधिकारियों, निदेशकों, कर्मचारियों, सहयोगियों, एजेंटों, लाइसेंसधारकों या आपूर्तिकर्ताओं के प्रदर्शन, गैर-प्रदर्शन या अन्य कार्यों या चूकों से संबंधित अन्य वारंटियां।'
								: 'other warranties relating to performance, non-performance, or other acts or omissions of NatureDots, its officers, directors, employees, affiliates, agents, licensors, or suppliers.'}
						</p>
						<p>
							5.3.{' '}
							{isHindiSelected
								? 'NatureDots किसी भी तीसरे पक्ष की सामग्री की विश्वसनीयता, सटीकता, पूर्णता, शुद्धता या उपयोगिता के संबंध में कोई प्रतिनिधित्व या वारंटी नहीं देता है और तीसरे पक्ष की सामग्री से उत्पन्न या संबंधित सभी दायित्वों को अस्वीकार करता है।'
								: 'NatureDots does not make any representation or warranty regarding the reliability, accuracy, completeness, correctness, or usefulness of third-party content, and disclaims all liabilities arising from or related to third-party content.'}
						</p>
						<p>
							5.4.{' '}
							{isHindiSelected
								? 'NatureDots वारंटी नहीं देता है कि वेबसाइट के साथ उपयोग और या लाइसेंस किए गए किसी भी सॉफ़्टवेयर का अन्य तीसरे पक्ष के सॉफ़्टवेयर या डिवाइसों के साथ संगतता होगी, न ही वह वारंटी देता है कि वेबसाइट और संबंधित सॉफ़्टवेयर का संचालन अन्य सॉफ़्टवेयर या हार्डवेयर को क्षति या व्यवधान नहीं पहुंचाएगा।'
								: 'NatureDots does not warrant that any of the software used and/or licensed in connection with the Website will be compatible with other third-party software or devices nor does it warrant that operation of the Website and the associated software will not damage or disrupt other software or hardware.'}
						</p>
						<p>
							5.5.{' '}
							{isHindiSelected
								? 'इन उपयोग की शर्तों में कहीं भी अन्यथा होने के बावजूद, किसी भी स्थिति में NatureDots उपयोगकर्ता या उपयोगकर्ता के तहत किसी भी व्यक्ति के लिए उपयोगकर्ता या उपयोगकर्ता के तहत किसी भी व्यक्ति द्वारा वहन या वहन किए गए किसी भी लागत या नुकसान के लिए उत्तरदायी नहीं होगा, जिसमें विशेष, उदाहरण, परिणामी, आकस्मिक, दंडात्मक या अप्रत्यक्ष क्षति शामिल हैं लेकिन इन तक सीमित नहीं हैं। किसी भी स्थिति या परिस्थिति में NatureDots किसी भी तरह के मौद्रिक भुगतान या अन्यथा के माध्यम से किसी भी नुकसान को ठीक करने के लिए उत्तरदायी नहीं होगा।'
								: 'Notwithstanding anything contained elsewhere in these Terms of Use, in no event NatureDots shall be liable to the User or anyone claiming under the User for any costs or loss incurred or suffered by the User or anyone claiming under the User, including but not limited to any special, exemplary, consequential, incidental, punitive or indirect damages on any theory of liability, whether in contract, tort (including without limitation negligence), strict liability or otherwise. In no event or circumstance will NatureDots be under any liability to make good any loss whether by way of any monetary payment or otherwise.'}
						</p>
						<p>
							5.6.{' '}
							{isHindiSelected
								? 'NatureDots या इसके किसी भी प्रतिनिधि, वेबसाइट को प्रशासित, वितरित या प्रदान करने में शामिल कोई भी व्यक्ति, किसी भी गलतियों, चूक, फाइलों या ईमेल को हटाने, त्रुटियों, दोषों, वायरस कंप्यूटर वायरस या अन्य हानिकारक, अक्षम कंप्यूटर कोड, कंप्यूटर निर्देश, सर्किटरी या अन्य तकनीकी साधनों के लिए कोई भी और सभी देनदारी स्पष्ट रूप से अस्वीकार करता है जिनका उद्देश्य किसी भी कंप्यूटर और संचार सुविधाओं या उपकरणों के साथ विघटन, क्षति या हस्तक्षेप करना है ("हानिकारक कोड") जो उपयोगकर्ता के डिवाइस में वेबसाइट का उपयोग करते समय स्थानांतरित किया जा सकता है। स्पष्टीकरण के लिए, हानिकारक कोड में बिना किसी सीमा के, किसी भी कोड में वायरस, ट्रोजन हॉर्स, वर्म या जैसे विनाशकारी कोड या कोड शामिल हैं जो जानबूझकर आत्म-प्रजनन करने के लिए लिखा गया था। उपयोगकर्ता को उचित एंटी-वायरस और सुरक्षा सॉफ़्टवेयर प्राप्त करने और उपयोग करने और अपने उपकरणों की अखंडता को सुरक्षित करने के लिए सभी अन्य उचित उपाय करने की सलाह दी जाती है।'
								: 'NatureDots or anyone on its behalf, involved in administering, distributing or providing the Website further explicitly disclaims any and all liability for any mistakes, omissions, interruptions, deletion of files or email, errors, defects, viruses computer viruses or other harmful, disabling computer code, computer instructions, circuitry or other technological means whose purpose is to disrupt, damage or interfere with any computer and communications facilities or equipment (“harmful code”) that may be transferred to the device of the User when accessing the Website. By way of clarification, harmful code shall include, without limitation, any code containing viruses, Trojan horses, worms or like destructive code or code that was intentionally written to self-replicate. The User is advised to obtain and use appropriate anti-virus and security software and to take all other appropriate measures to safeguard the integrity of its devices.'}
						</p>
					</div>
				</div>

				<div className='flex flex-col text-black'>
					<p className='text-black font-bold text-xl'>
						6. {isHindiSelected ? 'क्षतिपूर्ति' : 'INDEMNIFICATION'}
					</p>
					<div className='flex flex-col mt-1 text-sm font-normal leading-6 text-black ml-5'>
						<p>
							6.1.{' '}
							{isHindiSelected
								? 'उपयोग की शर्तों को स्वीकार करके और वेबसाइट का उपयोग करके, उपयोगकर्ता सहमत होते हैं कि वे NatureDots, इसके निदेशकों, शेयरधारकों, अधिकारियों और अन्य प्रतिनिधियों को किसी भी और सभी दावों, लागतों, क्षति, हानि, देनदारियों और खर्चों (जिसमें वकीलों की फीस और लागत शामिल हैं) से बचाव करेंगे, क्षतिपूर्ति करेंगे और अन्यथा हानिरहित रखेंगे, जो उत्पन्न होते हैं या जुड़े होते हैं:'
								: 'By accepting the Terms of Use and using the Website, the Users agree that they shall defend, indemnify and otherwise hold NatureDots, its directors, shareholders, officers and other representatives harmless from and against any and all claims, costs, damages, losses, liabilities and expenses (including attorneys’ fees and costs) arising out of or in connection with:'}
						</p>
						<p className='ml-2'>
							a){' '}
							{isHindiSelected ? 'वेबसाइट का उपयोग;' : 'access to the Website;'}
						</p>
						<p className='ml-2'>
							b){' '}
							{isHindiSelected
								? 'वेबसाइट की सेवाएँ/विशेषताएँ;'
								: 'services/features of the Website;'}
						</p>
						<p className='ml-2'>
							c){' '}
							{isHindiSelected
								? 'इन उपयोग की शर्तों या किसी भी लागू कानून या विनियम का उल्लंघन या उल्लंघन;'
								: 'violation or breach of these Terms of Use or any applicable law or regulation;'}
						</p>
						<p className='ml-2'>
							d){' '}
							{isHindiSelected
								? 'किसी भी तीसरे पक्ष के किसी भी अधिकार, जिसमें किसी व्यक्ति या इकाई की बौद्धिक संपदा या अन्य अधिकार शामिल हैं, का उल्लंघन; या'
								: 'violation of any rights of any third party including intellectual property or other rights of any person or entity; or'}
						</p>
						<p className='ml-2'>
							e){' '}
							{isHindiSelected
								? 'उपयोगकर्ता द्वारा प्रेषित किसी भी संचार के सामग्री पर आधारित किसी भी और सभी तीसरे पक्ष के दावे।'
								: 'any and all third-party claims based upon the content of any communications transmitted by the User.'}
						</p>
					</div>
				</div>

				<div className='flex flex-col text-black'>
					<p className='text-black font-bold text-xl'>
						7. {isHindiSelected ? 'समापन' : 'TERMINATION'}
					</p>
					<div className='flex flex-col mt-1 text-sm font-normal leading-6 text-black ml-5'>
						<p>
							7.1.{' '}
							{isHindiSelected
								? 'उपयोग की शर्तें तब तक प्रभावी रहेंगी जब तक कि इसे उपयोगकर्ता या NatureDots द्वारा समाप्त नहीं किया जाता।'
								: 'The Terms of Use shall continue to be in effect until they are terminated by either the User or NatureDots.'}
						</p>
						<p className='ml-2'>
							7.1.1.{' '}
							<strong>
								{isHindiSelected
									? 'उपयोगकर्ता द्वारा समापन:'
									: 'Termination by the User:'}
							</strong>{' '}
							{isHindiSelected
								? 'यदि उपयोगकर्ता उपयोग की शर्तों से बाध्य नहीं होना चाहता है, तो वह वेबसाइट तक पहुंच न करके NatureDots के साथ अपने संबंध को समाप्त कर सकता है। यदि उपयोगकर्ता वेबसाइट तक पहुंचना चाहता है, तो वह वेबसाइट का उपयोग करके उपयोग की शर्तों को स्वीकार करने के लिए समझा जाएगा।'
								: 'In case the User does not wish to be bound by the Terms of Use, they may terminate their relationship with NatureDots by not accessing the Website. If the user wishes to access the Website, they may do so. By accessing the Website, the User would be deemed to accept the Terms of Use.'}
						</p>
						<p className='ml-2'>
							7.1.2.{' '}
							<strong>
								{isHindiSelected
									? 'NatureDots द्वारा समापन:'
									: 'Termination by NatureDots:'}
							</strong>{' '}
							{isHindiSelected
								? 'NatureDots द्वारा समापन: NatureDots अपने विवेक में और किसी भी समय, किसी भी कारण से या बिना किसी सूचना के, उपयोग की शर्तों को समाप्त या निलंबित कर सकता है, यदि:'
								: 'NatureDots may at its discretion and at any time, with or without notice, terminate or suspend the Terms of Use, with or without cause, if:'}
						</p>
						<p className='ml-4'>
							a){' '}
							{isHindiSelected
								? 'उपयोगकर्ता उपयोग की शर्तों, गोपनीयता नीति या अन्य किसी भी शर्तों, शर्तों, या नीतियों का उल्लंघन करता है जो उपयोगकर्ता पर लागू हो सकती हैं;'
								: 'The User breaches any of the provisions of the Terms of Use, the Privacy Policy, or any other terms, conditions, or policies that may be applicable to the User;'}
						</p>
						<p className='ml-4'>
							b){' '}
							{isHindiSelected
								? 'NatureDots को कानून के अनुसार ऐसा करना आवश्यक है; या'
								: 'NatureDots is required to do so in accordance with law; or'}
						</p>
						<p className='ml-4'>
							c){' '}
							{isHindiSelected
								? 'NatureDots ने वेबसाइट (या इसके किसी भी हिस्से) तक पहुंच को, चाहे सामान्य रूप से या विशेष रूप से उपयोगकर्ता के लिए, किसी भी कारण से या बिना किसी कारण के बंद करने का फैसला किया है। NatureDots ऐसे किसी भी समापन के लिए उपयोगकर्ता या किसी भी तीसरे पक्ष के प्रति उत्तरदायी नहीं होगा।'
								: 'NatureDots has elected to discontinue, with or without reason, access to the Website (or any part thereof) either in general or specifically to the User. NatureDots shall not be liable to the user or any third party for any such termination.'}
						</p>
					</div>
				</div>

				<div className='flex flex-col text-black'>
					<p className='text-black font-bold text-xl'>
						8. {isHindiSelected ? 'सामान्य प्रावधान' : 'GENERAL PROVISIONS'}
					</p>
					<div className='flex flex-col mt-1 text-sm font-normal leading-6 text-black ml-5'>
						<p>
							{isHindiSelected
								? '1.1. उपयोग की शर्तें 01.08.2024 को अंतिम बार अपडेट की गई थीं। समय-समय पर, NatureDots उपयोग की शर्तों को बदल सकता है। NatureDots वेबसाइट पर अपडेट की गई उपयोग की शर्तों को भी पोस्ट करेगा। कृपया समय-समय पर वेबसाइट की जांच करें।'
								: '1.1. The Terms of Use were last updated on 01.08.2024. From time to time, NatureDots may change the Terms of Use. NatureDots shall also post the updated Terms of Use on the Website. Please check the Website periodically for updates.'}
						</p>
						<p>
							{isHindiSelected
								? '8.1. उपयोग की शर्तें वेबसाइट में या उससे जुड़ी किसी भी चीज में किसी भी टकराव या असंगतता के मामले में प्रभावी होंगी। उपयोग की शर्तों के किसी भी प्रावधान को लागू करने में NatureDots की विफलता को ऐसे प्रावधान या उसे लागू करने के अधिकार का त्याग या सहमति नहीं माना जाएगा। वेबसाइट तक पहुंच या उपयोग के किसी भी विच्छेद के बाद भी उपयोग की शर्तों के तहत NatureDots के अधिकार बने रहेंगे।'
								: '8.1. The Terms of Use shall supersede in case of any conflict or inconsistency of anything in or associated with the Website. NatureDots’ failure to enforce any provision of the Terms of Use shall not be deemed to be a waiver or acquiescence of such provision or the right to enforce such provision. Rights of NatureDots under the Terms of Use shall survive any discontinuance of the access or use of the Website.'}
						</p>
						<p>
							{isHindiSelected
								? '8.2. उपयोग की शर्तों और गोपनीयता नीति की शर्तों के बीच किसी भी टकराव की स्थिति में, टकराव की सीमा तक बाद वाली प्रभावी होगी।'
								: '8.2. In case of any conflict with the terms of the Terms of Use and the Privacy Policy, the latter shall prevail only to the extent of the conflict.'}
						</p>
						<p>
							{isHindiSelected
								? '8.3. यदि उपयोग की शर्तों का कोई भी प्रावधान अमान्य या अप्रवर्तनीय माना जाता है, तो ऐसा प्रावधान हटा दिया जाएगा और कानून के तहत पूरी तरह से प्रवर्तित किया जाएगा।'
								: '8.3. If any provision of the Terms of Use is held to be invalid or unenforceable, such provision shall be struck and the remaining provisions shall be enforced to the fullest extent under law.'}
						</p>
						<p>
							{isHindiSelected
								? '8.4. वेबसाइट या इन शर्तों के बारे में NatureDots से उपयोगकर्ता को कोई भी नोटिस इस वेबसाइट पर पोस्ट किया जाएगा या ईमेल या रेगुलर मेल द्वारा भेजा जाएगा।'
								: '8.4. Any notices to the User from NatureDots regarding the Website or these Terms will be posted on this Website or sent by e-mail or regular mail.'}
						</p>
						<p>
							{isHindiSelected
								? '8.5. उपयोग की शर्तों पर भारत के कानूनों द्वारा शासित और निर्मित किया जाएगा और उपयोग की शर्तों से उत्पन्न होने वाले सभी विवादों को सुलझाने के लिए नई दिल्ली के न्यायालयों के पास एकल अधिकार होगा'
								: '8.5. The Terms of Use shall be governed and construed under the laws of India and the courts of New Delhi shall have exclusive jurisdiction to adjudicate all disputes arising out of the Terms of Use.'}
						</p>
					</div>
				</div>
			</div>
			<p
				className='text-[#00208C] hidden sm:block font-bold text-2xl w-full text-center py-8 cursor-pointer'
				onClick={() => navigate('/privacypolicy')}
			>
				Read Privacy Policy
			</p>
			<div className='flex items-center w-full justify-center py-8 space-x-8'>
				<div
					className='px-[28px] py-3 flex items-center justify-center rounded-3xl text-black text-sm border border-[#00208C] cursor-pointer'
					onClick={() => navigate('/')}
				>
					Close
				</div>
				<div
					className='px-[28px] py-3 flex items-center justify-center rounded-3xl text-white text-sm border bg-[#00208C] cursor-pointer'
					onClick={() => navigate('/')}
				>
					Accept
				</div>
			</div>
		</div>
	);
}
